import React, { CSSProperties } from "react";
import cx from "classnames";
import styles from "./fieldset-footer-actions.module.scss";

export interface IFieldsetFooterActions {
  children?: React.ReactNode;
  className?: string;
  style?: CSSProperties;
  htmlId?: string;
}

export const FieldsetFooterActions = (props: IFieldsetFooterActions) => {
  return (
    <div className={cx(styles.fieldset_footer_actions, props.className)} style={props.style} id={props.htmlId}>
      {props.children}
    </div>
  );
};

FieldsetFooterActions.defaultProps = {};
